<template>
    <div>
        <input type="text" :placeholder="days" disabled>
        - Abre <input type="time" v-model="open">
        Fecha <input type="time" v-model="close">
        <b-button variant="success" class="ml-3" @click="defineHours(days)">Salvar</b-button>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';

export default {
    mixins: [makeToast],
    props: {
        open: {
            type: String,
            default: ""
        },

        close: {
            type: String,
            default: ""
        },
        
        days: {
            type: String,
            required: true,
            default: ""
        },

        dataShop: {
            type: String,
            required: true,
            default: ""
        },
    },

    computed: {
    ...mapState(['dadosUsuario']),
  },

    methods: {
        ...mapActions('shopkeeper', ['getOpeningHours', 'saveOpeningHours', 'updateOpeningHours']),

        defineHours(day) {
            const dataHours = {
                construp_user_id: this.dadosUsuario.id,
                day: day,
                opening: this.open,
                close: this.close
            };

            if (dataHours.day == "Feriados" || dataHours.day == "Domingo") {
                if (dataHours.opening == "" || dataHours.close =="") {
                    dataHours.opening = "Fechado!";
                }
            }

            if (!dataHours.opening) {
                this.makeToast(
                    'Oopss',
                    'Horários de funcionamento não podem estar vazios!',
                    'danger'
                );
                return;
            }
            
            this.dataShop.data.forEach(element => {
                if (element.construp_user_id == dataHours.construp_user_id) {
                    this.updateOpeningHours(dataHours);
                    return;                    
                }
            });


            this.saveOpeningHours(dataHours)
            .finally(() => {
                this.$store.dispatch('endLoader');
                this.makeToast(
                    'Sucesso!',
                    'Horário de funcionamento alterado!',
                    'success'
                );
            });
        },
    }
}
</script>